import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-methodology3',
  templateUrl: './methodology3.component.html',
  styleUrls: ['./methodology3.component.scss']
})
export class Methodology3Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
